import React from 'react';
import PropTypes from 'prop-types';
import Copy from 'copy-to-clipboard';
import { CTAButton } from 'shared-components/buttons/cta-button';
import { FormattedMessage } from 'react-intl';

const textAreaStyling = {
  height: '186px',
  overflow: 'hidden',
  resize: 'none',
  padding: '16px',
  marginBottom: '16px'
};

export class CopyEmbedScript extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      buttonCopy: <FormattedMessage id="hosting.host_embed_copy_component.copy_code_button_text" defaultMessage="Copy Code" />,
      buttonDisabled: false
    };

    this.copySnippet = this.copySnippet.bind(this);
    this.reset = this.reset.bind(this);
  }

  highlight () {
    const textArea = document.getElementById('snippet-window');
    textArea.focus();
    textArea.select();
  }

  deselect () {
    window.getSelection().removeAllRanges();
  }

  reset () {
    setTimeout(() => {
      const textArea = document.getElementById('snippet-window');
      textArea.blur();
      this.deselect();
      this.setState({
        buttonCopy: <FormattedMessage id="hosting.host_embed_copy_component.copied_button_text" defaultMessage="Copied!" />,
        buttonDisabled: false
      });
    }, 880);
    setTimeout(() => {
      this.setState({ buttonCopy: <FormattedMessage id="hosting.host_embed_copy_component.copy_code_button_text" defaultMessage="Copy Code" /> });
    }, 2500);
  }

  copySnippet () {
    this.setState({ buttonDisabled: true });
    const { snippet } = this.props;
    this.highlight('snippet-window');
    Copy(snippet);
    this.reset();
  }

  render () {
    const { snippet } = this.props;
    const { buttonCopy, buttonDisabled } = this.state;
    return (
      <div id="code-snippet-section">
        <textarea
          id="snippet-window"
          readOnly
          onClick={ this.copySnippet }
          style={ textAreaStyling }
          className="col-xs-12"
        >
          { snippet }
        </textarea>
        <CTAButton
          onClickAction={ this.copySnippet }
          buttonText={ buttonCopy }
          spinning={ buttonDisabled }
          isDisabled={ buttonDisabled }
          classNameString="col-xs-12 col-sm-4 btn btn-primary"
          style={{ height: '46px' }}
        />
      </div>
    );
  }
}

CopyEmbedScript.propTypes = {
  snippet: PropTypes.string
};
